import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import BlankState from '../components/BlankState';
import Page from '../components/Page';

import DataTable from '../components/DataTable2';
import { fetchPaginated } from './../actions/qoutes';

class Qoutes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quotes: [],
      page: 1
    };
  }

  componentDidMount() {
    this.props.fetchPaginated();
  }
  onClickPrev = () => {
    const page = this.state.page;
    this.setState(
      {
        page: page - 1
      },
      () => {
        this.props.fetchPaginated(this.state.page);
      }
    );
  };
  onClickNext = () => {
    const page = this.state.page;
    this.setState(
      {
        page: page + 1
      },
      () => {
        this.props.fetchPaginated(this.state.page);
      }
    );
  };
  render() {
    const { quotes } = this.props;
    //const results = quotes.quotes.results;
    const nextUrl =
      quotes.quotes && quotes.quotes.next ? quotes.quotes.next : '';
    const previousUrl =
      quotes.quotes && quotes.quotes.previous ? quotes.quotes.previous : '';
    return (
      <Page isAdminPage={true} pageTitle="Quotes">
        <div className="clearfix card">
          {quotes.quotes.results && quotes.quotes.results.length > 0 ? (
            <DataTable
              onClickNext={this.onClickNext}
              onClickPrev={this.onClickPrev}
              tableId="quotes-table"
              next={nextUrl}
              previous={previousUrl}
              columnTitles={[
                'Name',
                'Duration Of cover',
                'Total sum insured',
                'Total CFR'
              ]}
            >
              {quotes.quotes.results.map((qoute, index) => {
                return (
                  <tr key={index}>
                    <td>{qoute.proposer_name}</td>
                    <td>{qoute.duration_of_cover}</td>
                    <td>{qoute.total_sum_insured}</td>
                    <td>{qoute.total_cfr}</td>
                  </tr>
                );
              })}
            </DataTable>
          ) : (
            <BlankState
              data={quotes.quotes.results}
              dataName="Quotes"
              isDataLoading={quotes.quotes_loading}
            />
          )}
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  quotes: state.quotes
});
const mapDispatchToProps = dispatch => {
  return bindActionCreators({ fetchPaginated }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(Qoutes);



// WEBPACK FOOTER //
// ./src/pages/QoutesPagination.js